<template>
  <formulario-base class="auto-form-wrapper" :error="error">
    <form action="#" slot="formulario">
      <div class="form-group">
        <p>Ingresa tu correo electrónico para recuperar tu contraseña</p>
        <div class="input-group">
          <input v-model="email" type="text" class="form-control" placeholder="Correo electrónico">
          <!--<div class="input-group-append">
                <span class="input-group-text">
                    <i class="mdi mdi-check-circle-outline"></i>
                </span>
          </div>-->
        </div>
      </div>

      <div class="form-group">
        <button
          class="btn btn-primary submit-btn btn-block"
          @click.prevent="recuperarPassword"
        >Enviar</button>
      </div>

      <div class="form-group d-flex justify-content-center">
        <router-link to="/" class="forgot-password">Regresar</router-link>
      </div>

      <div color="success" v-show="Boolean(exito)">{{exito}}</div>
    </form>
  </formulario-base>
</template>

<script>
import FormularioBase from "./FormBase.vue";
import { mixinFormulario } from "@/mixins/mixins";
import errors from "../../errors";
export default {
  components: { FormularioBase },
  mixins: [mixinFormulario],
  data() {
    return {
      exito: ""
    };
  },
  methods: {
    recuperarPassword() {
      this.cargandoFormulario = true;
      this.$store
        .dispatch("recuperarPassword", this.email)
        .then(() => {
          this.cargandoFormulario = false;
          this.exito =
            "Se ha enviado un mensaje a su correo electrónico para el reestablecimiento de su contraseña.";
        })
        .catch(error => {
          this.cargandoFormulario = false;
          this.error = errors(error.code);
        });
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/vistas/Auth/FormRecuperar.vue